import { setCookie, getCookie } from './cookies.js'

//== close notification strip and set/get cookie
document.addEventListener('DOMContentLoaded', () => {
  const notificationStrips = document.querySelectorAll('[data-znotif]')

  notificationStrips.forEach((notif) => {
    const id = notif.id

    if (getCookie(`sz-ns-${id}`)) {
      notif.style.display = 'none'
    }

    const expiryAttr = notif.getAttribute('data-znotif-expiry')
    const expiry = expiryAttr !== null ? parseInt(expiryAttr, 10) : 14
    const closeButton = notif.querySelector('.btn-close-notif')

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        notif.style.display = 'none'
        setCookie(`sz-ns-${id}`, true, expiry)
      })
    }
  })
})
